export default __webpack_public_path__ + "static/vnPay-164ac40e5cb00d66850b7be6e6d75bfd.png";